import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import Icon from './Icon'

export class Symbol extends Component {

    render() {
        let crypto = this.props.litecoin === true ? true : false
        let fiatCode = this.props.litecoin === true ? 'LTC' : this.props.currencyCode

        return (
            <Div>
                <Left>
                    <Icon litecoin={crypto} />
                </Left>
                <Right>
                    <P>{fiatCode}</P>
                </Right>
            </Div>
        )
    }
}

const Div = styled.div`
    height: 44px;
    width: 80px;
    border: 1px solid #E6E7E8;
    border-radius: 2px;
    background-color: #FAFAFA;
    box-shadow: 0 1px 0 0 rgba(0,0,0,0.08);
    display: flex;
    flex-direction: row;
`

const Left = styled.div`
    flex-grow: 1;
    align-self: center;
    text-align: center;
`

const Right = styled.div`
    flex-grow: 1;
    align-self: center;
`

const P = styled.p`
	color: #B3B3B3;
	font-family: Helvetica;
	font-size: 12px;
`

const mapStateToProps = (state) => ({
    currencyCode: state.buy.params.currencyCode
})

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(Symbol)
